import React from "react";

import {
  TrendingUp,
  Users,
  Globe,
  MessageCircle,
} from "lucide-react";

const STATS = [
  {
    icon: Users,
    value: "50+",
    label: "Businesses Supported",
  },

  {
    icon: Globe,
    value: "100+",
    label: "Web Pages Delivered",
  },

  {
    icon: MessageCircle,
    value: "1K+",
    label: "Customer Inquiries Generated",
  },

  {
    icon: TrendingUp,
    value: "4.9★",
    label: "Client Satisfaction",
  },
];

export default function Stats() {
  return (
    <section className="py-20 lg:py-24 bg-[var(--gf-primary)] text-white">

      <div className="max-w-7xl mx-auto px-5 lg:px-8">

        {/* Heading */}
        <div className="max-w-3xl mx-auto text-center">

          <p className="text-xs uppercase tracking-[0.22em] font-bold text-[var(--gf-blue)]">
            Growth Numbers
          </p>

          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08]">
            Helping businesses grow online.
          </h2>

          <p className="mt-5 text-lg text-white/70 leading-relaxed">
            GrowFlow builds modern websites and digital systems
            designed to generate real business growth.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-3xl border border-white/10 bg-white/5 p-8 text-center hover:-translate-y-1 transition-all duration-300"
            >

              {/* Icon */}
              <div className="mx-auto h-14 w-14 rounded-2xl bg-white/10 flex items-center justify-center">

                <s.icon className="h-6 w-6 text-[var(--gf-blue)]" />

              </div>

              {/* Number */}
              <h3 className="font-display mt-6 text-4xl font-extrabold">
                {s.value}
              </h3>

              {/* Label */}
              <p className="mt-2 text-sm text-white/70">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
